<template>
    <div>
        <HeaderBg :img="img" title="عروض المنتجات" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteCity" 
            messege="هل أنت متأكد من مسح العرض ؟"
        />
        <header class="admin_content_header">
            <div class="filter">
                <!-- <select>
                    <option value="" selected disabled>المدينة</option>
                </select> -->
            </div>
            <div class="search">
                <!-- <input type="text" placeholder="البحث برقم الفرع"> -->
            </div>
            <router-link to="/store-admin/offers/add-offer"> + إضافة عرض جديد </router-link>
            
        </header>
        <RequestSpinner v-if="loadingRequest == true" />
        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th>اسم العرض</th>
                        <th>نوع العرض</th>
                        <th>نسبة الخصم</th>
                        <th>التصنيف</th>
                        <th>الحالة</th>
                        <th>تاريخ البدء</th>
                        <th>تاريخ الانتهاء</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="offer in offers" :key="offer.id">
                        <td> {{offer.translation[0].name}} </td>
                        <td> {{offer.type}} </td>
                        <td> {{offer.discount_amount}} </td>
                        <td> - </td>
                        <td> {{offer.status == 1 ? 'مفعل' : 'غير مفعل'}} </td>
                        <td>  {{offer.start_date}} </td>
                        <td>  {{offer.end_date}} </td>

                        <td>
                            <div class="block actions">
                                <div class="delete" @click="() => deleteData(offer.id)">
                                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                                </div>
                                <div class="edit" @click="() => editOffer(offer.id)">
                                    <img src="../../../assets/images/editLogo.svg" alt="">
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="pagination mt-5" v-if="cities.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div> -->
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import store from "@/store/index.js";
import Request from '../../../services/Request';
import Alert from '../../global/Alert/Alert';

export default {
    name: 'Offers',
    components: {HeaderBg, RequestSpinner, Alert},
    data(){
        return{
            loadingRequest: true,
            img: require('../../../assets/images/saleWhite.svg'),
            offers: [],

            deleteID: '',
            alertToggle: false,

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,

            add_offers_permission: false,
            edit_offers_permission: false,
            delete_offers_permission: false,
        }
    },
    mounted(){
        // var permissions = JSON.parse(localStorage.getItem("permissions"));

        // if(permissions.includes('list offers')){
        //     console.log('permission')
        // } else {
        //     this.$router.push('/login')
        // }

        // if(permissions.includes('add offers')){
        //     this.add_offers_permission = true
        // } 
        // if(permissions.includes('update offers')) {
        //     this.edit_offers_permission = true
        // } 
        // if(permissions.includes('delete offers')) {
        //     this.delete_offers_permission = true
        // } 


        // get pagination page number from url
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');
        if(page){
            this.currentPage = page
        }
        this.getOffers();
    },
    methods:{
        getOffers(){
            Request.fetch('admin/newOffer', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                console.log(response.data)
                this.offers = response.data.data
                this.loadingRequest = false;
                this.pages = Math.ceil(response.data.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        editOffer(id){
            this.$router.push(`/store-admin/offers/add-offer/${id}`)
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteCity(){
            this.loadingRequest = true;
            Request.delete('admin/newOffer',this.deleteID)
            .then( () => {
                this.getOffers();
            })
        },

        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getOffers();
            } else{
                this.apiParams = `?page=${val}`;
                this.getOffers();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.saveBtn{
    margin-top: 0;
    display: block;
    &:hover{
        color: #FFF;
    }
}
.actions{
    display: flex;
    align-items: center;
    .delete,
    .edit{
        width: 40px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FF002B;
        cursor: pointer;
        svg{
            color: #FFF;
            font-size: 25px;
        }
    }
    .edit{
        background-color: #78A28F;
        margin-right: 10px;
    }
}
</style>